<template>
  <div>

    <b-table striped responsive hover thead-class="table-active"
             :items="products.data"
             :fields="fields"
             show-empty
             empty-text="No hay productos para mostrar">

      <template v-slot:cell(nombre)="data">
        <p>{{ data.item.nombre }}</p>
        <b-badge v-if="data.item.is_imported" variant="success">Importado</b-badge>
        <b-badge v-else variant="danger">Sin importar</b-badge>
        <br>
        <b-badge v-if="data.item.is_made" variant="info">Fabricado</b-badge>
      </template>

      <template v-slot:cell(fecha)="data">
        <div v-if="data.item.adjuntos.length">
          <el-tooltip  effect="dark" placement="top" content="Descargar Adjunto" popper-class="py-1 px-2"
                       v-for="adjunto in data.item.adjuntos" :key="adjunto.id">
            <b-button @click="downloadFile(adjunto, data.item)" class="buttonAdjunto mb-1">
                <span v-if="adjunto.fecha" class="text-nowrap">
                  {{ adjunto.fecha }}
                </span>
            </b-button>
          </el-tooltip>
        </div>
        <i class="text-muted" v-else>No registra</i>
      </template>


      <template v-slot:cell(importation)="data">
        <b-button size="sm" :disabled="!filtro.empresa" @click="goFormCreateHistorical(data.item)" variant="primary">Registrar importación</b-button>
      </template>

      <template v-slot:cell(year_importation)="data">

        <template v-if="data.item.producto_empresa && data.item.producto_empresa.length">
          <template
              v-if="data.item.producto_empresa[0]['dcr_historical_imports_products'] && data.item.producto_empresa[0]['dcr_historical_imports_products'].length">
            <b-badge pill variant="light">
              <span style="font-size: 12px">{{ data.item.producto_empresa[0]['dcr_historical_imports_products'][0]['year_import'] }}</span>
            </b-badge>
          </template>
          <i class="text-muted" v-else>No aplica</i>
        </template>

      </template>

      <template v-slot:cell(quantity_purchased_kg)="data">

        <template v-if="data.item.producto_empresa && data.item.producto_empresa.length">
          <template
              v-if="data.item.producto_empresa[0]['dcr_historical_imports_products'] && data.item.producto_empresa[0]['dcr_historical_imports_products'].length">
            {{ data.item.producto_empresa[0]['dcr_historical_imports_products'][0]['quantity_purchased_kg'] }}
          </template>
          <i class="text-muted" v-else>No aplica</i>
        </template>
      </template>

    </b-table>


    <el-pagination class="float-right" v-model="filtro.page" @size-change="setPerPagePagination"
                   @current-change="setPagePagination" :current-page="filtro.page" :page-sizes="[10, 30, 50, 100]"
                   :page-size="filtro.perPage" layout="total,sizes, prev, pager, next" :total="products.total"/>


  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {validarRol} from "@/plugins/acl";
import ModalFormHistorical from './ModalFormHistorical.vue'

export default {
  name: "DataTable",
  components: {
    ModalFormHistorical
  },
  data() {
    return {
      fields: [
        {
          key: "nombre",
          label: "Nombre",
          sortable: true
        },
        {
          key: "fabricante.nombre",
          label: "Fabricante",
          sortable: true
        },
        {
          key: "fecha",
          label: "Fecha FDS",
          sortable: true,
          thStyle: {
            "min-width": "130px !important",
            width: "130px !important",
          },
        },
        {
          key: "year_importation",
          label: "Año de importación",
          thStyle: { width: "200px"},
          tdClass: 'text-right',
        },
        {
          key: "quantity_purchased_kg",
          label: "Cantidad comprada KG",
          thStyle: { width: "200px"},
          tdClass: 'text-right',
        },
        {
          key: "importation",
          label: "Importación",
          thStyle: { width: "200px"},
          tdClass: "text-nowrap"
        }
      ],
      payload: {
        prod_products_id: null,
        company_id: null,
        is_imported: true,
        quantity_purchased_kg: 0,
        year_import: new Date(new Date().setFullYear(new Date().getFullYear() - 1))
      }
    }
  },
  methods: {
    ...mapActions('adjuntos', ['descargarAdjunto']),
    ...mapActions('productos', ['setPerPagePagination', 'setPagePagination']),
    ...mapActions('decret_1630', ['getPrDcrHistoricalImports']),
    async downloadFile(adj, producto) {
      adj.producto = producto.nombre;
      await this.descargarAdjunto(adj);
      window.open(process.env.VUE_APP_API_URL + "storage/files/" + adj.adjunto);
    },
    goFormCreateHistorical({id}) {
      this.$router.push({name: 'decreto-1630-crear', params: {prod_product_id: id, company_id: this.filtro.empresa}})
    }
  },
  computed: {
    ...mapState('productos', ['filtro']),
    ...mapState('decret_1630', ['company_id', 'products']),
  },
  watch: {
    'filtro.page': async function (val) {
      if (!this.filtro.empresa) return;
      if (!val) {
        this.filtro.page = 1;
      }
      await this.getPrDcrHistoricalImports(this.filtro)
    }
  }
}
</script>

<style scoped>

</style>
